<template>
    <div class="container-fluid">
           <net-pa-card>
                <template slot="header">
                    <h6 class="text-right">
                    <i class="fas fa-help"></i> پیگیری درخواست های وام
                    <span class="float-left" @click="$router.go(-1)">
                        <i
                        data-v-9331d9a2=""
                        title="بازگشت به صفحه قبلی"
                        class="fas fa-arrow-left text-light Pointer"
                        style="float: left; font-size: 18px"
                        ></i
                    ></span>
                    </h6>
                </template>
                <template slot="content">

                    <div class="container">
                        <div v-if="NeedVamList.length >0" class="row p-3">
                            <div v-for="(item, index) in NeedVamList" :key="index" class="col-12 border mt-4 p-4 bnp-rounded border Netpa-Shadow">
                                <div class="row">
                                    <div class="col-12 col-md-3">
                                        <span class="text-secondary">نوع تسهیلات: </span>
                                        <span class="font-weight-bold">
                                            {{item.desNoe}}
                                        </span>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <span class="text-secondary">تاریخ درخواست : </span>
                                        <span class="font-weight-bold">
                                            {{item.requestTarix}}
                                        </span>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <span class="text-secondary">مبلغ تسهیلات  : </span>
                                        <span class="font-weight-bold">
                                            {{$Comma3ragham(item.mablagh)}}
                                        </span>
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <span class="text-secondary">وضعیت تایید صندوق : </span>
                                        <span v-if="item.isModirTaeed == 0" class="badge badge-warning">
                                            <i class="far fa-hourglass"></i> <i>در حال بررسی </i> 
                                        </span>
                                        <span v-if="item.isModirTaeed == 1" class="badge badge-success">
                                            <i class="fas fa-check"></i> <i>تایید شده</i>
                                        </span>
                                        <span v-if="item.isModirTaeed == 2" class="badge badge-danger">
                                            <i class="fas fa-times"></i> <i>رد شده </i>
                                        </span>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <a  @click="dropdown(index)" class="Pointer">
                                            <i class="fas fa-chevron-circle-down text-primary"></i>  مشاهده جزئیات
                                        </a>
                                    </div>
                                </div>
                                <span :id="'needBody' + index " class="NeedDropDown NoShow">
                                    <hr class="my-3">
                                    <div class="row">
                                        <!-- <div class="col-12">
                                            <span class="font-weight-bold"> وضعیت ضامنین</span>
                                        </div> -->
                                        
                                        <div class="col-12 col-md-4 border-right border-info">
                                            <div v-if="item.zamenName1 ==''" class="row">
                                                <span class="font-weight-bold"> برای ضامن اول اطلاعاتی وارد نشده است</span>
                                            </div>
                                            <div v-else class="row border-"> 
                                                <div class="col-12">
                                                    <span class="text-secondary">مشخصات ضامن اول: </span>
                                                    <span>{{item.zamenName1}}</span>
                                                </div>
                                                <div class="col-12 mt-1">
                                                    <span class="text-secondary">وضعیت تایید: </span>
                                                    <span v-if="item.zamenIsTaeed1 == 0" class="badge badge-warning">
                                                        <i class="far fa-hourglass"></i> <i>در حال بررسی </i> 
                                                    </span>
                                                    <span v-if="item.zamenIsTaeed1 == 1" class="badge badge-success">
                                                        <i class="fas fa-check"></i> <i>تایید شده</i>
                                                    </span>
                                                    <span v-if="item.zamenIsTaeed1 == 2" class="badge badge-danger">
                                                        <i class="fas fa-times"></i> <i>رد شده </i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 border-right border-info">
                                            <div v-if="item.zamenName1 ==''" class="row">
                                                <span class="font-weight-bold"> برای ضامن دوم اطلاعاتی وارد نشده است</span>
                                            </div>
                                            <div v-else class="row"> 
                                                <div class="col-12">
                                                    <span class="text-secondary"> مشخصات ضامن دوم: </span>
                                                    <span>{{item.zamenName2}}</span>
                                                </div>
                                                <div class="col-12 mt-1">
                                                    <span class="text-secondary">وضعیت تایید: </span>
                                                    <span v-if="item.zamenIsTaeed2 == 0" class="badge badge-warning">
                                                        <i class="far fa-hourglass"></i> <i>در حال بررسی </i> 
                                                    </span>
                                                    <span v-if="item.zamenIsTaeed2 == 1" class="badge badge-success">
                                                        <i class="fas fa-check"></i> <i>تایید شده</i>
                                                    </span>
                                                    <span v-if="item.zamenIsTaeed2 == 2" class="badge badge-danger">
                                                        <i class="fas fa-times"></i> <i>رد شده </i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 border-right border-info">
                                            <div v-if="item.zamenName1 ==''" class="row">
                                                <span class="font-weight-bold"> برای ضامن سوم اطلاعاتی وارد نشده است</span>
                                            </div>
                                            <div v-else class="row"> 
                                                <div class="col-12">
                                                    <span class="text-secondary"> مشخصات ضامن سوم: </span>
                                                    <span>{{item.zamenName3}}</span>
                                                </div>
                                                <div class="col-12 mt-1">
                                                    <span class="text-secondary">وضعیت تایید: </span>
                                                    <span v-if="item.zamenIsTaeed3 == 0" class="badge badge-warning">
                                                        <i class="far fa-hourglass"></i> <i>در حال بررسی </i> 
                                                    </span>
                                                    <span v-if="item.zamenIsTaeed3 == 1" class="badge badge-success">
                                                        <i class="fas fa-check"></i> <i>تایید شده</i>
                                                    </span>
                                                    <span v-if="item.zamenIsTaeed3 == 2" class="badge badge-danger">
                                                        <i class="fas fa-times"></i> <i>رد شده </i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    <hr class="my-3">
                                    <div class="row">
                                        <div class="col-12">
                                            <span class="text-secondary">
                                                شرح اصلاحات توسط مدیر صندوق : 
                                            </span>
                                            <span v-if="item.sharhEslahatByModir == null || item.sharhEslahatByModir == ''  ">
                                                اصلاحی وجود ندارد
                                            </span>
                                            <span v-else>
                                                {{item.sharhEslahatByModir}}
                                            </span>
                                    
                                        </div>
                                    </div>
                                </span>

                            </div>
                        </div>
                        <div v-else class="row p-3">
                            <div  class="alert alert-warning col-12 bnp-rounded border Netpa-Shadow border-warning" style="height:50vh">
                                <span style="font-size:14px !important; font-weight:bold">
                                    درخواستی برای نمایش وجود ندارد
                                </span>
                            </div>
                        </div>
                    </div>
                </template>
            </net-pa-card>
    </div>
</template>


<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
    export default {
        components: { NetPaCard },
        data() {
            return {
                    loanFollowup:"loanFollowup",
                    NeedVamList:[]
                }
            },
        created(){

        },
        mounted(){
                        var formdata = new FormData();
            formdata.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
            var DataAxiosNeedVam = {
                ArryfildValue: formdata,
                Method: "Post",
                Action: "ListNeedVam",
                Token: this.$session.get("TokenNetPa"),
            }
            this.$PostFormData(DataAxiosNeedVam).then((data) => {
                this.NeedVamList = data;
            });
        },
        methods: {
            dropdown(index){
                if (document.getElementById("needBody"+index).classList.contains('NoShow')) {
                    document.getElementById("needBody"+index).classList.remove('NoShow')
                    document.getElementById("needBody"+index).classList.add('ShowNeed')
                }else{
                    document.getElementById("needBody"+index).classList.remove('ShowNeed')
                    document.getElementById("needBody"+index).classList.add('NoShow')
                }
            }
        },
    }
</script>
<style scoped>
.badge{
    font-weight: normal !important;
    font-size: 10px !important;
}
.NoShow{
    display: none !important;
    max-height: 0;
    transition: max-height 0.15s ease-out;
    overflow: hidden;
    /* background: #d5d5d5; */
}
.ShowNeed{
    display: block !important;
    max-height: 100%;
    transition: max-height 0.15s ease-out;
    overflow: hidden;
}


</style>